import React from 'react';

const Dashboard = () => {
    return (
        <div className='w-11/12 mx-auto'>
            <h1 className='text-5xl font-bold text-center underline'>Dashboard Layout</h1>
            <p className='text-lg font-semibold text-center my-24'>Will be Implemented Soon.................</p>
        </div>
    );
};

export default Dashboard;